import { useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import HoursCard  from "../components/HoursCard";

const STORE_HOURS = [
  { day: "Monday – Friday", time: "7:00 am – 11:00 pm" },
  { day: "Saturday",        time: "7:00 am – 11:00 pm"  },
  { day: "Sunday",          time: "8:00 am – 11:00 pm"  },
];

// For the "Find Us" card we reuse HoursCard with plain text rows
const LOCATION_ROWS = [
  { day: "Address", time: "London ON" },
  { day: "Phone",   time: "###-###-####"                        },
  { day: "Email",   time: "privateconvenience@gmail.com"         },
];

const EMPTY_FORM = { first: "", last: "", email: "", phone: "", message: "" };

function validate({ first, last, email, phone, message }) {
  if (first.trim().length < 2)          return "Please enter your first name.";
  if (last.trim().length < 2)           return "Please enter your last name.";
  if (!email.includes("@") || !email.includes(".")) return "Please enter a valid email.";
  if (phone.replace(/\D/g, "").length < 10)         return "Please enter a valid 10-digit phone number.";
  if (message.trim().length < 10)       return "Please write a longer message.";
  return null; // no errors
}

export default function ContactPage() {
  const [form, setForm]           = useState(EMPTY_FORM);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]         = useState("");

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationError = validate(form);
    if (validationError) {
      setError(validationError);
      return;
    }
    setError("");
    setSubmitted(true);
  };

  const handleReset = () => {
    setForm(EMPTY_FORM);
    setSubmitted(false);
    setError("");
  };

  const crumbs = [
    { label: "Home", page: "home" },
    { label: "Contact Us" },
  ];

  return (
    <div className="page-wrap fade-up">
      <Breadcrumb crumbs={crumbs} />

      <div className="contact-layout">

        {/* ── Left: Form ── */}
        <div className="form-card">
          {submitted ? (
            <div className="success-box">
              <div className="success-icon">✅</div>
              <h3>Message Sent!</h3>
              <p>We'll get back to you as soon as possible.</p>
              <button
                className="form-submit"
                style={{ marginTop: 16, maxWidth: 200 }}
                onClick={handleReset}
              >
                Send Another
              </button>
            </div>
          ) : (
            <>
              <h2>Send Us a Message</h2>
              <p className="form-intro">
                Have a question or request? We'd love to hear from you.
              </p>

              {error && (
                <p style={{ color: "var(--red)", fontSize: "0.84rem", marginBottom: 14, fontWeight: 700 }}>
                  ⚠️ {error}
                </p>
              )}

              <form onSubmit={handleSubmit} noValidate>
                <div className="form-row2">
                  <div className="form-group">
                    <label className="form-label">First Name *</label>
                    <input
                      className="form-input"
                      placeholder="Jane"
                      value={form.first}
                      onChange={handleChange("first")}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Last Name *</label>
                    <input
                      className="form-input"
                      placeholder="Doe"
                      value={form.last}
                      onChange={handleChange("last")}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input
                    className="form-input"
                    type="email"
                    placeholder="jane@example.com"
                    value={form.email}
                    onChange={handleChange("email")}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Phone Number *</label>
                  <input
                    className="form-input"
                    placeholder="519-000-0000"
                    value={form.phone}
                    onChange={handleChange("phone")}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Message *</label>
                  <textarea
                    className="form-textarea"
                    placeholder="What's on your mind?"
                    value={form.message}
                    onChange={handleChange("message")}
                  />
                </div>

                <button type="submit" className="form-submit">
                  Send Message →
                </button>
              </form>
            </>
          )}
        </div>

        {/* ── Right: Location + Hours ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <HoursCard
            icon="📍"
            title="Find Us"
            rows={LOCATION_ROWS}
          />
          <HoursCard
            icon="🕐"
            title="Store Hours"
            rows={STORE_HOURS}
            note="⚠️ Hours subject to change during holidays."
          />
        </div>

      </div>
    </div>
  );
}
